import { render, staticRenderFns } from "./SystemRoles.vue?vue&type=template&id=5b2488a2&scoped=true"
import script from "./SystemRoles.vue?vue&type=script&lang=js"
export * from "./SystemRoles.vue?vue&type=script&lang=js"
import style0 from "./SystemRoles.vue?vue&type=style&index=0&id=5b2488a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2488a2",
  null
  
)

export default component.exports